import { useI18n } from "@/lib/i18n";

/**
 * A record's name in the language the screen is in.
 *
 * Every menu item, category, addon, station and area carries `nameAr` and an
 * OPTIONAL `nameEn`, and much of this app printed `nameAr` unconditionally. On
 * an English screen that put Arabic dish names beside English labels — the till
 * read "French fries" nowhere and "بطاطس مقلية" everywhere, next to a price and
 * the word "ADDONS".
 *
 * Arabic is the fallback, never English: `nameEn` is optional and frequently
 * blank (a seller types the Arabic name and moves on), and an empty string in a
 * list is worse than a name in the other language — it is a row you cannot
 * identify at all.
 *
 * A hook rather than a bare function so it reads the active locale the same way
 * `useRoleName` does, and so a component cannot forget to pass it.
 */
export function useLocalName() {
  const { locale } = useI18n();
  return (item: { nameAr: string; nameEn?: string | null }): string =>
    locale === "en" && item.nameEn ? item.nameEn : item.nameAr;
}
